import { twMerge } from "tailwind-merge";
import PropTypes from "prop-types";
import React from "react";

function Button({ disabled, onClick, className, ...props }) {
  const c = twMerge(
    "h-10 mb-0 rounded-md bg-[#0947AB] text-semibold mt-0 p-0",
    className
  );

  return (
    <button {...props} className={c} onClick={onClick} disabled={disabled} />
  );
}

Button.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.any,
  onClick: PropTypes.func,
};
export default Button;
